import { READ_DIR_PAGE_LIMIT } from '../../constants';
import { withNetworkRetry, } from './with-network-retry';
export async function* readDirWithRetry(fileSystem, entryKey, options) {
    let cursor;
    do {
        const pageCursor = cursor;
        const page = await withNetworkRetry(() => fileSystem.readDirPaginated(entryKey.id, READ_DIR_PAGE_LIMIT, pageCursor), options);
        yield* page.items;
        cursor = page.nextCursor;
    } while (cursor);
}
